'use client';
import React from 'react';
import MuiBox from '@new-components/atoms/MuiBox';
import MuiTypography from '@new-components/atoms/MuiTypography';
import RangeInputs from '@new-components/atoms/RangeInputs';
import {SelectionType} from '@new-components/organisms/SearchPriceFilter';

type AreaSelectorProps = {
  step?: number;
  min?: number;
  max?: number;
  suffix?: string;
  value: SelectionType;
  handleChange: (value: SelectionType) => void;
  label: string;
};

const AreaSelector = (props: AreaSelectorProps) => {
  const [minPrice, setMinPrice] = React.useState<number | string | null>(
    props.value.min || null
  );
  const [maxPrice, setMaxPrice] = React.useState<number | string | null>(
    props.value.max || null
  );

  React.useEffect(() => {
    setMinPrice(props.value.min);
    setMaxPrice(props.value.max);
  }, [props.value.min, props.value.max]);

  React.useEffect(() => {
    props.handleChange({min: minPrice, max: maxPrice});
  }, [minPrice, maxPrice]);

  const handleMinInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.valueAsNumber;
    if (value < 0) {
        return;
    }
    setMinPrice(value);
  };
  const handleMaxInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.valueAsNumber;
    if (value < 0) {
      return;
  }
    setMaxPrice(value);
  };
  const handleMinBlur = () => {
    const minValue = Number(minPrice);
    const maxValue = Number(maxPrice);

    if (props.min && minValue <= props.min) {
      setMinPrice(props.min);
      return;
    } else if (props.max && props.step && minValue >= props.max) {
      setMinPrice(props.max - props.step);
      return;
    } else if (maxValue && minValue >= maxValue) {
      setMinPrice(maxValue - 1);
      return;
    }
  };
  const handleMaxBlur = () => {
    const minValue = Number(minPrice);
    const maxValue = Number(maxPrice);

    if (props.max && maxValue >= props.max) {
      setMaxPrice(props.max);
      return;
    } else if (props.min && props.step && maxValue <= props.min) {
      setMaxPrice(props.min + props.step);
      return;
    } else if (minValue && maxValue <= minValue) {
      setMaxPrice(minValue + 1);
      return;
    }
  };
  return (
    <MuiBox>
      <MuiTypography
        sx={{
          fontSize: '17px',
          fontWeight: 500,
          letterSpacing: '-0.4px',
          color: '#000000',
          marginBottom: '8px',
        }}>
        {props.label}
      </MuiTypography>
      <RangeInputs
        handleMaxInputChange={handleMaxInputChange}
        handleMinInputChange={handleMinInputChange}
        handleMinBlur={handleMinBlur}
        handleMaxBlur={handleMaxBlur}
        maxPlaceholder='Max'
        minPlaceholder='Min'
        maxValue={maxPrice as number}
        minValue={minPrice as number}
        suffix={props.suffix}
        step={props.step}
      />
    </MuiBox>
  );
};
export default AreaSelector;
